import './src/utils/globals.css';

export const onClientEntry = () => {
  // Load Raleway font from Google Fonts
  if (typeof window !== 'undefined') {
    const id = 'google-font-raleway';
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css?family=Raleway:400,500,600,700&display=swap';
      document.head.appendChild(link);
    }
  }
};
